export default __webpack_public_path__ + "static/media/Redux-Logo.a9567540.svg";